import React, { useContext, useState } from 'react';
import PageLayout from '../pagelayout';
import { useIntl } from 'react-intl';
import * as css from './pagenotfound.module.scss';
import { RenderPageNotFoundContext } from './pagenotfoundStore';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../components/button';

export const PageNotFoundWithoutLayout: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const errorTitle: string = intl.formatMessage({
    id: 'pagenotfound.errorTitle',
    defaultMessage: '[!] Ukjent blindpunkt.',
  });

  const errorMessage: string = intl.formatMessage({
    id: 'pagenotfound.errorMessage',
    defaultMessage:
      '[!] Siden du leter etter eksisterer ikke. Det kan være at du feilstavet nettadressen eller at siden ble flyttet på.',
  });

  const linkToDashboard: string = intl.formatMessage({
    id: 'pagenotfound.linkToDashboard',
    defaultMessage: '[!] Til dashboard',
  });

  const subtitle: string = intl.formatMessage({
    id: 'pagenotfound.subtitle',
    defaultMessage: '[!] Siden du leter etter eksisterer ikke',
  });

  return (
    <div className={css.pagenotfound}>
      <div className={css.space65} />
      <div className={css.illustration}>
        <h1>{errorTitle}</h1>
        <h2>{subtitle}</h2>
        <div className={css.spaceForIllustration} />
      </div>
      <div className={css.footer}>
        <h3>{errorMessage}</h3>
        <div className={css.space24} />
        <Button.Secondary role={'link'} onClick={() => navigate(`/`)}>
          {linkToDashboard}
        </Button.Secondary>
      </div>
    </div>
  );
};

const PageNotFoundPage = () => {
  const { renderPageNotFound } = useContext(RenderPageNotFoundContext);
  const [currentPath, setCurrentPath] = useState<string>();
  const location = useLocation();

  const intl = useIntl();

  const title: string = intl.formatMessage({
    id: 'pagenotfound.title',
    defaultMessage: '[!] Siden eksisterer ikke',
  });

  const subtitle: string = intl.formatMessage({
    id: 'pagenotfound.subtitle',
    defaultMessage: '[!] Siden du leter etter eksisterer ikke',
  });

  React.useEffect(() => {
    setCurrentPath(window.location.pathname);

    return () => {
      renderPageNotFound(false);
    };
  }, [renderPageNotFound]);

  React.useEffect(() => {
    if (currentPath && currentPath !== location.pathname) {
      renderPageNotFound(false);
    }
  }, [location.pathname, currentPath, renderPageNotFound]);

  return (
    <PageLayout isIndented title={title} subtitle={subtitle}>
      <PageNotFoundWithoutLayout />
    </PageLayout>
  );
};

export default PageNotFoundPage;
